var _style, _path, _path2, _path3, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0C98BC;}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M489.2,94.5H21.9c-9.1,0-14.8,1.4-17.9,4.3c-2.7,3.3-4,8.7-4,16.7v29.9v24.1v172.3V367v28.8   c0,14.3,7.4,21.7,21.9,21.7h467.3c15.2,0,22.8-7.4,22.8-21.7V367v-25.2V169.4v-24.1v-29.9C512,101.3,504.4,94.5,489.2,94.5z"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M449.1,264.1l-16.4,0c-0.8,0-5.9-0.2-11.5,2.1v-2.1l-33.1,0c-0.8,0-5.8-0.2-11.3,2v-2h-9.4h-48.7v1.9    c-5.2-2.2-10.3-2.1-12.2-1.9h-39.6v1.6c-4.9-1.9-9.6-1.8-11.3-1.7h-30.3l-9.7,0.1h-4.1c0,0-6.6,7.1-10.4,11.3    c-3.8-4.2-10.4-11.4-10.4-11.4h-59.4v68.5h60.4c0,0,6.1-6.6,9.3-10.2c3.2,3.6,9.3,10.2,9.3,10.2h37c0,0,0-12.8,0-16c1.1,0,3,0,3,0    c5.6,0,11.5-0.5,16.7-2.6v18.7h31.3c0,0,0-13.3,0-17.3c0.8,0,1.8,0,2.1,0c0,1.3-0.1,7.9-0.1,7.9v9.4h31v-0.1h45.6v-0.1l18.8,0    c0.7,0,1.5,0.1,1.5,0.1c3.7,0,7.6-0.8,11.2-2.2v2.2l31.8,0c0.7,0,1.5,0.1,1.5,0.1c4.2,0,8.7-1,12.7-3c0.7-0.3,1.4-0.6,2-1v0.1    c1.6-1,3.8-2.9,6.2-6.2v-1.5v-56.8H449.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.6,237.8c4.2,0,6.5,0,10.7,0c1,2.3,4.4,10.4,4.4,10.4h40.5c0,0,0-1,0-1.3c0.2,0.5,0.6,1.3,0.6,1.3H152    c0,0,0.3-0.7,0.5-1.1c0,0.2,0,1.1,0,1.1h29.1h2.4h34.2h12.1h19.2c0,0,0-13.3,0-17.3c0.7,0,1.8,0,2.1,0c0,1.3-0.1,7.9-0.1,7.9v9.4    h27.9c0,0,0,0.2,0,0.2h22.1V244c3.8,2.4,7.7,3.8,10.6,4.2l0.7,0.1h26.7c0,0,3.4-8.1,4.4-10.4c4.2,0,6.5,0,10.7,0    c1,2.4,4.5,10.4,4.5,10.4h40.3c0,0,0-8.2,0-8.9c0.6,1,5.4,8.9,5.4,8.9h32.1v-68.4h-31.4c0,0,0,7.2,0,8.5c-0.5-0.9-5.2-8.5-5.2-8.5    h-32.5c0,0,0,6.1,0,8c-0.1-0.2-3.4-8-3.4-8h-30.1l0,0.1c-0.6,0-17.5-0.5-17.5-0.5c-5.3,0.2-10.5,1.7-15.1,4.6v-4.1h-9.4h-22.1v1.9    c-5.2-2.2-10.3-2.1-12.2-1.9h-27.5H221h-2.8H184h-9.4h-2.4h-23.6c0,0-5.3,11.8-7.8,17.4c-2.5-5.6-7.8-17.4-7.8-17.4H97.7    c0,0,0,7.4,0,8.6c-0.1-0.3-3.6-8.6-3.6-8.6H63.9l-13.9,33v35.4h19.1C69.1,248.3,72.6,240.2,73.6,237.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M261.1,238.9v-9.7c0,0-0.5-7.6-8.4-7.6h-12.3v17.3h-12.6v-49.7h30.6c0,0,16-1.9,16,14.6       c0,8.6-7.1,11.6-7.1,11.6s6.1,2.9,6.1,11.3v12.3H261.1 M240.4,210h13c3.8,0,6.9-2.1,6.9-4.7c0-2.6-3.1-4.7-6.9-4.7h-13V210       L240.4,210",
    id: "SVGID_1_"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 213.655,
    cy: 96.1619,
    gradientTransform: "matrix(2.7367 0 0 2.7367 -478.8621 -168.9253)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_2_",
    r: 178.9584
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#009ACA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5077,
    style: {
      stopColor: "#0090BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8347,
    style: {
      stopColor: "#006D8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00607E"
    }
  })), /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible",
      fill: "url(#SVGID_2_)"
    },
    xlinkHref: "#SVGID_1_"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_1_"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M410,238.9l-20-33.2v33.2h-10.9h-2h-11.9l-4.5-10.4h-23.1l-4.4,10.4h-11.6h-2.1h-6.1c0,0-17-2.4-17-23.5       c0-27.6,19.3-26.5,19.9-26.7l15.6,0.4v11.2l-12.8,0.2c0,0-8.3,0-9.4,10.9c-0.1,1.2-0.2,2.4-0.2,3.5c0,16.8,14.6,11.6,15.1,11.4       l15.7-37.1h17.7l18.9,45.1v-45.1H395l19.8,32.7v-32.7h12.7v49.7H410 M343.1,215.8h12.3l-6.1-14.8L343.1,215.8L343.1,215.8",
    id: "SVGID_4_"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 213.6506,
    cy: 96.1602,
    gradientTransform: "matrix(2.7367 0 0 2.7367 -478.8621 -168.9253)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_5_",
    r: 178.9647
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#009ACA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5077,
    style: {
      stopColor: "#0090BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8347,
    style: {
      stopColor: "#006D8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00607E"
    }
  })), /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible",
      fill: "url(#SVGID_5_)"
    },
    xlinkHref: "#SVGID_4_"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_4_"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M162,238.9v-34.3l-15.8,34.3h-10.3l-15.9-34.2v34.2h-11h-1.7H95l-4.4-10.4h-23l-4.5,10.4H49.3l20.9-49.7       H88l19.2,45.7v-45.7h19.9l13.9,30.9l13.8-30.9h19.9v49.7H162 M73,215.8h12.3L79.1,201L73,215.8L73,215.8",
    id: "SVGID_7_"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 213.6501,
    cy: 96.1644,
    gradientTransform: "matrix(2.7367 0 0 2.7367 -478.8621 -168.9253)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_8_",
    r: 178.9634
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#009ACA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5077,
    style: {
      stopColor: "#0090BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8347,
    style: {
      stopColor: "#006D8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00607E"
    }
  })), /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible",
      fill: "url(#SVGID_8_)"
    },
    xlinkHref: "#SVGID_7_"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_7_"
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_10_",
    points: "181.8,238.9 181.8,189.2 221.2,189.2 221.2,200.8 194.5,200.8 194.5,208.4 220.5,208.4        220.5,219.7 194.5,219.7 194.5,228.1 221.2,228.1 221.2,238.9 181.8,238.9      "
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 213.6549,
    cy: 96.1644,
    gradientTransform: "matrix(2.7367 0 0 2.7367 -478.8621 -168.9253)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_11_",
    r: 178.9503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#009ACA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5077,
    style: {
      stopColor: "#0090BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8347,
    style: {
      stopColor: "#006D8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00607E"
    }
  })), /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible",
      fill: "url(#SVGID_11_)"
    },
    xlinkHref: "#SVGID_10_"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_10_"
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_13_",
    points: "279.6,239.1 279.6,189.2 292.3,189.2 292.3,239.1 279.6,239.1      "
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 213.6645,
    cy: 96.1657,
    gradientTransform: "matrix(2.7367 0 0 2.7367 -478.8621 -168.9253)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_14_",
    r: 178.9394
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#009ACA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5077,
    style: {
      stopColor: "#0090BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8347,
    style: {
      stopColor: "#006D8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00607E"
    }
  })), /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible",
      fill: "url(#SVGID_14_)"
    },
    xlinkHref: "#SVGID_13_"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_15_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_13_"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M309.8,323.2v-9.7c0,0-0.5-7.6-8.4-7.6h-12.3v17.2h-12.6v-49.7h30.6c0,0,16-1.9,16,14.6       c0,8.6-7.1,11.6-7.1,11.6s6.1,2.9,6.1,11.3v12.3H309.8 M289.1,294.3h13c3.8,0,6.9-2.1,6.9-4.7c0-2.6-3.1-4.7-6.9-4.7h-13V294.3       L289.1,294.3",
    id: "SVGID_16_"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 213.649,
    cy: 96.164,
    gradientTransform: "matrix(2.7367 0 0 2.7367 -478.8621 -168.9253)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_17_",
    r: 178.9625
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#009ACA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5077,
    style: {
      stopColor: "#0090BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8347,
    style: {
      stopColor: "#006D8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00607E"
    }
  })), /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible",
      fill: "url(#SVGID_17_)"
    },
    xlinkHref: "#SVGID_16_"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_16_"
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M225.6,323.2h-11l-13.4-14.7l-13.5,14.7h-7.7h-39.3v-49.8h39.3h6.7l14.5,15.8l14.6-15.7h9.7v-0.1h30.6       c0,0,16-1.8,16,14.6c0,14.6-5.3,19.2-21.6,19.2h-12.4v16H225.6 M209.8,298.7l15.7,17.3v-34.6L209.8,298.7L209.8,298.7        M153.5,312.4h26.6l12.5-13.7L180.1,285h-26.6v7.7h25.9V304h-25.9V312.4L153.5,312.4 M238.1,294.2h13c3.8,0,6.9-2.1,6.9-4.7       c0-2.6-3.1-4.7-6.9-4.7h-13V294.2L238.1,294.2",
    id: "SVGID_19_"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 213.65,
    cy: 96.1631,
    gradientTransform: "matrix(2.7367 0 0 2.7367 -478.8621 -168.9253)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_20_",
    r: 178.967
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#009ACA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5077,
    style: {
      stopColor: "#0090BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8347,
    style: {
      stopColor: "#006D8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00607E"
    }
  })), /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible",
      fill: "url(#SVGID_20_)"
    },
    xlinkHref: "#SVGID_19_"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_21_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_19_"
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M395.9,323.1h-22.5v-11.5h19.7c0,0,7.1,0.8,7.1-3.9c0-4.5-10.7-4.1-10.7-4.1s-17.4,1.5-17.4-14.8       c0-16.2,15.7-15.3,15.7-15.3h24.2V285h-19.5c0,0-6.7-1.4-6.7,3.5c0,4.1,9.2,3.5,9.2,3.5s19.3-1.4,19.3,13.6       c0,16.1-12.4,17.5-16.8,17.5C396.5,323.1,395.9,323.1,395.9,323.1",
    id: "SVGID_22_"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 213.6434,
    cy: 96.166,
    gradientTransform: "matrix(2.7367 0 0 2.7367 -478.8621 -168.9253)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_23_",
    r: 178.9719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#009ACA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5077,
    style: {
      stopColor: "#0090BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8347,
    style: {
      stopColor: "#006D8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00607E"
    }
  })), /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible",
      fill: "url(#SVGID_23_)"
    },
    xlinkHref: "#SVGID_22_"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_22_"
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_25_",
    points: "328.3,323.2 328.3,273.5 367.7,273.5 367.7,285 341,285 341,292.7 367,292.7 367,304 341,304        341,312.4 367.7,312.4 367.7,323.2 328.3,323.2      "
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 213.6456,
    cy: 96.1644,
    gradientTransform: "matrix(2.7367 0 0 2.7367 -478.8621 -168.9253)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_26_",
    r: 178.9715
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#009ACA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5077,
    style: {
      stopColor: "#0090BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8347,
    style: {
      stopColor: "#006D8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00607E"
    }
  })), /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible",
      fill: "url(#SVGID_26_)"
    },
    xlinkHref: "#SVGID_25_"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_27_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_25_"
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M440.4,323.1h-22.5v-11.5h19.6c0,0,7.2,0.8,7.2-3.9c0-4.5-10.7-4.1-10.7-4.1s-17.4,1.5-17.4-14.8       c0-16.2,15.7-15.3,15.7-15.3h24.2V285H437c0,0-6.7-1.4-6.7,3.5c0,4.1,9.2,3.5,9.2,3.5s19.3-1.4,19.3,13.6       c0,16.1-12.4,17.5-16.8,17.5C441,323.1,440.4,323.1,440.4,323.1",
    id: "SVGID_28_"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 213.6517,
    cy: 96.166,
    gradientTransform: "matrix(2.7367 0 0 2.7367 -478.8621 -168.9253)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_29_",
    r: 178.9586
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#009ACA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5077,
    style: {
      stopColor: "#0090BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8347,
    style: {
      stopColor: "#006D8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00607E"
    }
  })), /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible",
      fill: "url(#SVGID_29_)"
    },
    xlinkHref: "#SVGID_28_"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_28_"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M454.5,329.5l-0.1,0.1c0,0,0.8-0.3,2.1-1.1v-0.1C455.8,328.8,455.1,329.1,454.5,329.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.e6d7706307ce73989d33db6304d70603.svg";
export { ForwardRef as ReactComponent };